import { SvgIconFromSheet } from '@cinch-nx/search-ui-svg-icon-sheet'

export interface HeartIconProps {
  name: 'Filled' | 'Outline'
  size: number
}

export const HeartIcon = ({ name, size }: HeartIconProps) => (
  <SvgIconFromSheet
    name={`heart${name}${size}Icon`}
    size={size}
    fill={'url(#svg-gradient-alpha)'}
  />
)
